import React from "react"
import InfoItem from "../../../components/InfoCard/Info-item"

export const infoItem = (page) => (
    <InfoItem label="Página" value={page}/>
)

export const verifyOcr = (ocr, ocrState, fields) => {
    if (!ocr) return fields

    return fields.map((field) => {
        if (field.ocrMd !== undefined) {
            const ocrMd = Number(field.ocrMd)

            if (!Number.isNaN(ocrMd)) {
                field.md = ocrMd
            }
        }

        if (field.ocr === false) {
            return {
                ...field
            }
        }

        const key = field.key
        const ocrField = ocrState[key]

        const gridSpacing = field.md === 12 ? 11.35: 10
        const extraGridSpacing = field.md === 12 ? 1: 2

        return {
            ...field,
            gridSpacing: {xs: gridSpacing, md: gridSpacing, xl: gridSpacing,},
            extraContent: {
                content: infoItem(ocrField?.page ?? "-"),
                gridSpacing: extraGridSpacing,
            },
        }
    })
}